// extracted by mini-css-extract-plugin
export default {"skeleton":"c403c4"};